import type { SVGProps } from "react";
import * as React from "react";

const SvgGrid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 3V2a1 1 0 0 0-1 1zm7 0h1a1 1 0 0 0-1-1zm0 7v1a1 1 0 0 0 1-1zm-7 0H2a1 1 0 0 0 1 1zm11-7V2a1 1 0 0 0-1 1zm7 0h1a1 1 0 0 0-1-1zm0 7v1a1 1 0 0 0 1-1zm-7 0h-1a1 1 0 0 0 1 1zm0 4v-1a1 1 0 0 0-1 1zm7 0h1a1 1 0 0 0-1-1zm0 7v1a1 1 0 0 0 1-1zm-7 0h-1a1 1 0 0 0 1 1zM3 14v-1a1 1 0 0 0-1 1zm7 0h1a1 1 0 0 0-1-1zm0 7v1a1 1 0 0 0 1-1zm-7 0H2a1 1 0 0 0 1 1zM3 4h7V2H3zm6-1v7h2V3zm1 6H3v2h7zm-6 1V3H2v7zm10-6h7V2h-7zm6-1v7h2V3zm1 6h-7v2h7zm-6 1V3h-2v7zm-1 5h7v-2h-7zm6-1v7h2v-7zm1 6h-7v2h7zm-6 1v-7h-2v7zM3 15h7v-2H3zm6-1v7h2v-7zm1 6H3v2h7zm-6 1v-7H2v7z"
    />
  </svg>
);
export default SvgGrid;
